import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	innerHtmlTextField: {
		width: '100%',
		backgroundColor: '#D7DBDD',
		marginTop: '1rem !important'
	},
	device: {
		magin: '4rem',
		padding: '1rem',
		marginTop: '2rem',
		marginLeft: '15rem'
	},
	deviceConfig: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		backgroundColor: theme.palette.secondary.main,
		padding: '2rem',
		borderRadius: '5px',
		width: '60%',
		marginTop: '1rem'
	}
}));
